import React, { useEffect, useState, useRef } from 'react';
import * as S from './style';
import {assetPath} from '../../../utils/web-helper';
import { BackgroundElements, VerticalMovementIndex, RotationalMovementIndex, BackgroundMovementDelay } from '../../../constant-data/splashverse-onboarding';
import UsePrevious from '../../common/hooks/usePreviousValue';
import useResize from '../../loggedout/custom-hooks/resize';

const SplashVerseBackground = ({...props}) => {

  const [BackgroundElementsState, mutateBackgroundElement] = useState(BackgroundElements)
  const screenHeight = useResize().height;
  const prevIndex = UsePrevious(props.currentStepIndex)
  
  useEffect(() => {
    // the following check is for the first load where prevIndex will be undefined
    if(typeof(prevIndex) !== 'undefined') {
      setTimeout(() => {
        backOrForwardBGHandler(props.currentStepIndex < prevIndex);
      }, BackgroundMovementDelay)
    }
  }, [props.currentStepIndex])

  const backOrForwardBGHandler = (back = false) => {
    let BackgroundElementsStateCopy = [];
    BackgroundElementsState.map((imgObj) => {
      let updatedImgObj = imgObj;
      let verticalMovementIndex = updatedImgObj.isSquareDots ? VerticalMovementIndex - 30 : VerticalMovementIndex;
      let shiftDifference = props.currentStepIndex - prevIndex;
      if (back) {
        updatedImgObj.initPos.Y += verticalMovementIndex * -1 * shiftDifference;
        updatedImgObj.initPos.deg += 
          RotationalMovementIndex * 
          (updatedImgObj.initPos.placement === 'left' ? -1 * Math.abs(shiftDifference) : 1 * Math.abs(shiftDifference));
      } else {
        updatedImgObj.initPos.Y -= verticalMovementIndex * shiftDifference;
        updatedImgObj.initPos.deg += 
          RotationalMovementIndex * 
          (updatedImgObj.initPos.placement === 'left' ? 1 * Math.abs(shiftDifference) : -1 * Math.abs(shiftDifference));
      }
      BackgroundElementsStateCopy.push(updatedImgObj);
    })
    mutateBackgroundElement(BackgroundElementsStateCopy);
  }

  return (
    <S.BackgroundContainer screenH={screenHeight}>
      {BackgroundElementsState.map((imageObj) => {
        return (
          <S.ElementWrap initPos={imageObj.initPos}>
            <img src={assetPath(imageObj.img)}></img>
          </S.ElementWrap>
        )
      })}
    </S.BackgroundContainer>
  )
}

export default SplashVerseBackground;